import getCookies from '../../utils/getCookies.js'
import setCookies from '../../utils/setCookies.js'

export default
{
    components:
    {

    },

    props:
    {
        iconColor: { type: String, default: 'dark' },
        postType: { type: String, default: '' },
        slug: { type: String, default: '' },
        hasInfowindow: { type: Boolean, default: false }
    },

    data()
    {
        return {
            isFav: false
        }
    },

    created()
    {
        if(getCookies('selections'))
        {
            getCookies('selections').split(' ').forEach(selection =>
            {
                const part = selection.split('/')

                if(part[0] === this.postType && part[1] === decodeURIComponent(this.slug))
                {
                    this.isFav = true
                }
            })
        }
    },

    methods:
    {
        onToggleFav()
        {
            this.isFav = !this.isFav

            let currCookies = getCookies('selections')

            if(this.isFav)
            {
                setCookies('selections', currCookies + ' ' + this.postType + '/' + decodeURIComponent(this.slug))
            }
            else
            {
                setCookies('selections', currCookies.replace(this.postType + '/' + decodeURIComponent(this.slug), ''))
            }

            this.eventHub.$emit('fav:update')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-fav/script.js